import { defineStore } from 'pinia';
import { apiFetch } from '../composition/useAxios';
import type { TicketStore } from './TicketStore.interface';

export const useTicketStore = defineStore('ticket', {
  state: (): TicketStore => {
    return {
      version: '1.0.0',
      ticketList: [],
      fullTicketList: [],
      ticketParlayList: [],
      fullTicketPagination: null,
      fullTicketSummary: 0,
    };
  },
  actions: {
    async getTicketList() {
      try {
        const { data } = await apiFetch('/ticket/list ', { method: 'GET' });
        if (data?.value) {
          this.ticketList = data.value;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getFullTicketList(page: number) {
      try {
        const { data } = await apiFetch(
          `/ticket/list/full?page=${page}&limit=40`,
          {
            method: 'GET',
          }
        );
        if (data?.value) {
          if (page === 1) {
            this.fullTicketList = data.value.items;
          } else {
            this.fullTicketList = [...this.fullTicketList, ...data.value.items];
          }
          this.fullTicketPagination = data.value.pagination;
          this.fullTicketSummary = data.value.summary;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getTicketParlayList(ticketId: number) {
      try {
        const { data } = await apiFetch(`/ticket/${ticketId}/parlay/list`, {
          method: 'GET',
        });
        if (data?.value) {
          this.ticketParlayList = data.value;
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
});
